import React, {Component} from "react"
import {Select} from "@irati/ui/src/FormItem"
import {orderBy} from "lodash"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {Occasion} from "@irati/types"
import OccasionsService from "@irati/recognition/services/Occasions"

import {OccasionIcon, RoundIconWrapper} from "./styled"

interface Props extends InjectIntl {
  onChange: (selectedOption: string) => void,
  selectedOption?: string
}

interface State {
  options: Option[]
}

class OccasionsSelect extends Component<Props, State> {
  state: State = {
    options: []
  }

  componentDidMount() {
    const {formatMessage} = this.props
    OccasionsService.getAll().then((occasions) => {
      const sortedOccasions = orderBy(occasions, "createdAt", "desc")
      const options = sortedOccasions
        .filter((occasion: Occasion) => !occasion.archived)
        .map((occasion: Occasion) => {
          const name = occasion.default ? formatMessage({id: occasion.name}) : occasion.name
          const iconHref = occasion.default ? formatMessage({id: occasion.icon.href}) : occasion.icon.href
          const iconAlt = occasion.default ? formatMessage({id: occasion.icon.alt}) : occasion.icon.alt
          return {
            label: (
              <>
                <RoundIconWrapper>
                  <OccasionIcon src={iconHref} alt={iconAlt} />
                </RoundIconWrapper>
                {name}
              </>
            ),
            value: occasion.uuid
          }
        })
      this.setState({options})
    })
  }

  handleChange = (value: string) => {
    const {onChange} = this.props
    if (value) {
      onChange(value)
    } else {
      onChange("")
    }
  }

  render() {
    const {options} = this.state
    const {selectedOption} = this.props
    return (
      <Select
        id="companyCelebration"
        isSearchable={false}
        isClearable
        label="platform.fields.occasions.select.label"
        value={selectedOption}
        onChange={this.handleChange}
        options={options} />
    )
  }
}

export default injectIntl(OccasionsSelect)
